import { c as _c } from "react/compiler-runtime";
import type { VaultObjectData, VaultValue } from '@onefootprint/core';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { Form, Tooltip } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useField from '../../hooks/use-field';
import FieldValue from './components/field-value';
export type FieldProps = {
  di: DataIdentifier;
  entity: Entity;
  renderLabel?: () => React.ReactNode;
  renderValue?: (value: VaultValue | VaultObjectData, isValueDecrypted: boolean) => React.ReactNode;
  monospaced?: boolean;
};
const Field = t0 => {
  const $ = _c(32);
  const {
    di,
    entity,
    renderValue,
    renderLabel,
    monospaced
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "decrypt"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const t2 = useField(entity);
  let customLabel;
  let field;
  let label;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== di || $[2] !== renderLabel || $[3] !== t || $[4] !== t2) {
    field = t2(di);
    let t7;
    if ($[12] !== renderLabel) {
      t7 = renderLabel ? renderLabel() : undefined;
      $[12] = renderLabel;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    customLabel = t7;
    label = customLabel ?? field.label;
    const ariaLabel = typeof customLabel === "string" ? customLabel : field.label;
    const getTooltipText = () => {
      if (field.isEmpty) {
        return t(_temp, {
          field: field.label
        });
      }
      if (field.isDecrypted) {
        return t(_temp2, {
          field: field.label
        });
      }
      return t(_temp3);
    };
    t4 = "grid min-w-0 grid-cols-[fit-content(60%)_minmax(0,1fr)] gap-x-6 py-1.5";
    t5 = ariaLabel;
    const t8 = !field.showCheckbox;
    let t9;
    if ($[14] !== t8) {
      t9 = cx("flex min-w-0", {
        hidden: t8
      });
      $[14] = t8;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    t6 = <div className={t9}><Tooltip disabled={field.canDecrypt} content={getTooltipText()}><div className="flex"><Form.Checkbox name="fields" value={di} disabled={field.disabled} label={<div className="text-body-2 text-tertiary">{label}</div>} /></div></Tooltip></div>;
    t3 = cx("min-w-0 text-label-2 text-primary", {
      hidden: field.showCheckbox
    });
    $[1] = di;
    $[2] = renderLabel;
    $[3] = t;
    $[4] = t2;
    $[5] = customLabel;
    $[6] = field;
    $[7] = label;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    customLabel = $[5];
    field = $[6];
    label = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[16] !== customLabel || $[17] !== label) {
    t7 = customLabel && React.isValidElement(customLabel) ? customLabel : <div className="text-body-2 text-tertiary wrap-anywhere">{label}</div>;
    $[16] = customLabel;
    $[17] = label;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[19] = t3;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== field || $[23] !== monospaced || $[24] !== renderValue) {
    t9 = <div className="flex min-w-0 justify-end"><FieldValue field={field} renderValue={renderValue} monospaced={monospaced} /></div>;
    $[22] = field;
    $[23] = monospaced;
    $[24] = renderValue;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t8 || $[30] !== t9) {
    t10 = <fieldset className={t4} aria-label={t5}>{t6}{t8}{t9}</fieldset>;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
export default Field;
function _temp($) {
  return $.fieldEmptyNotAllowed;
}
function _temp2($_0) {
  return $_0.fieldDecryptedNotAllowed;
}
function _temp3($_1) {
  return $_1.notAllowed;
}